export class M3PDinamicas {
    public Valor:string;
    public Nombre:string;
}